import { render, staticRenderFns } from "./EditEdipart.vue?vue&type=template&id=d8876ca6&scoped=true&"
import script from "./EditEdipart.vue?vue&type=script&lang=js&"
export * from "./EditEdipart.vue?vue&type=script&lang=js&"
import style0 from "./EditEdipart.vue?vue&type=style&index=0&id=d8876ca6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8876ca6",
  null
  
)

/* custom blocks */
import block0 from "./EditEdipart.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports